import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterPagoNotaCobroView.
 * @extends JetView
 */
export default class FilterPagoNotaCobroView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for IdNota
                            name: 'IdNota',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Id Nota de Retiro'),
                            labelPosition: 'top',
                            placeholder: _('Id Nota de Retiro'),
                            required: true,
                            invalidMessage: _('Campo Requerido'), // Error message for required field
                        },
                        {
                            view: 'text', // Input for Clave
                            name: 'Clave',
                            type: 'password',
                            label: "<span class='icon-key'></span>" + _('Clave'),
                            labelPosition: 'top',
                            placeholder: _('Clave'),
                            required: true,
                            invalidMessage: _('Campo Requerido'), // Error message for required field
                        },
                        { id: 'grav2', gravity: 1 }, // Placeholder for layout
                    ],
                },
            ],
        };

        // Upper section containing the left section
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Data object for payment information
        const datos = {
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };

        // Button section with actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Placeholder for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                                $$('tablePagoNotaRetiro').hide(); // Hides the table
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                if (this.getRoot().validate()) {
                                    // Validates the form
                                    const filterdata = this.getRoot().getValues(); // Gets form values
                                    this.app.callEvent('pagoNotaRetiro:filter', [filterdata]); // Calls event with filter data
                                    $$('tablePagoNotaRetiro').show(); // Shows the table
                                }
                            },
                        },
                    ],
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form',
            scroll: 'y',
            rows: [upper_section, buttons],
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        this.validate(); // Validates on change
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Checks screen width for responsive design
                $$('grav').hide(); // Hides element if screen is small
                $$('grav2').hide(); // Hides element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
